import React from 'react';
import PageWrapper from "../../components/page-wrapper/page-wrapper";
import LoginSignupForm from "../../components/login-signup-form/login-signup-form";

export const Register = () => {
    return (
        <PageWrapper>
            <div className="container-fluid">
                <div className="row justify-content-center my-5 py-5">
                    <LoginSignupForm />
                </div>
            </div>
        </PageWrapper>
    );
};
